import { CONTACT_NUMBER } from "../../const.js";

export const ContactSupportTeamWhatsapp = () => {
  const message = encodeURIComponent("need support");
  const whatsappUrl = `https://wa.me/${CONTACT_NUMBER}?text=${message}`;
  window.open(whatsappUrl, "_blank");
};
